import React, { PureComponent } from 'react'
import { Button, Modal, Col, Tooltip, Glyphicon, OverlayTrigger } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import InputSelect from '../../commons/form/InputSelect'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import InputText from '../../commons/form/InputText'
import SimpleInputText from '../../commons/simpleForm/SimpleInputText'
import { handleKeyDown } from '../../../util/utils'

class FaqMasterModal extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      text: '',
      totalText: '',
      visibleCustom: false,
      lan: 0,
      idx: 0
    }
  }

  submitFaq (values) {
    let faqSectionId = null
    let rating = null
    const body = []

    Object.keys(values.languageList).map(item => {
      let languageId = values.languageList[item].languageId
      body.push(values[`lang${languageId}`])
    })
    faqSectionId = values.faqSectionId
    rating = values.rating
    this.props.actions.saveFaqMasterModal(faqSectionId, body, this.props.faqId, rating)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.showFaqModal !== this.props.showFaqModal && this.props.showFaqModal === true) {
      this.props.initialize({ ...this.props })
    }

    if (this.props.faqTranslations !== prevProps.faqTranslations) {
      this.props.languageList.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const nextFaqTranslation = this.props.faqTranslations.find((sourceChannel) => sourceChannel.languageId === language.languageId)
        if (nextFaqTranslation && nextFaqTranslation !== undefined) {
          this.props.change(`lang${language.languageId}.name`, nextFaqTranslation.name)
          this.props.change(`lang${language.languageId}.description`, nextFaqTranslation.description)
        }
      })
    }

    if (this.props.rating !== prevProps.rating) {
      this.props.change('rating', this.props.rating ? this.props.rating.toString() : '')
    }
    if (this.props.organizedUnitId !== prevProps.organizedUnitId) {
      this.props.change('organizedUnitId', this.props.organizedUnitId ? this.props.organizedUnitId.toString() : '')
    }
    if (this.props.faqSectionId !== prevProps.faqSectionId) {
      this.props.change('faqSectionId', this.props.faqSectionId ? this.props.faqSectionId : '')
    }
  }

  handleOrganizedUnitChange (filterUO) {
    let uo = filterUO === undefined ? null : filterUO
    this.props.actions.fecthFaqSectionComboModal(uo)
  }

  format (idx, lan) {
    this.setState({ lan: lan })
    this.setState({ idx: idx })
    if (this.props.faqTranslations[idx]?.description !== undefined) {
      this.setState({ totalText: this.props.faqTranslations[idx]?.description })
    }
    this.setState({ visibleCustom: true })
  }

  addFormat (beginning, end) {
    this.setState({ text: `${beginning}${this.state.text}${end}` })
  }

  addText () {
    this.setState({ totalText: `${this.state.totalText}${this.state.text}` })
    this.setState({ text: '' })
  }

  saveFormat () {
    if (this.state.totalText) {
      this.props.faqTranslations[this.state.idx] = { description: this.setState.totalText }
      this.props.change(`lang${this.state.lan}.description`, this.state.totalText)
      this.setState({ visibleCustom: false })
      this.setState({ totalText: '' })
    }
  }

  render () {
    const { t, showFaqModal, handleSubmit, languageList = [], combos: { faqSectionCombo, UOTreeCombo }, actions: { closeFaqModal } } = this.props
    const renderToolTip = (<Tooltip id="infoTooltip">{t('MASTERS.FAQ.TOOLTIP_OU')}</Tooltip>)
    const formatBold = (<OverlayTrigger placement="left" overlay={<Tooltip id="infoTooltip">{t('MASTERS.BOLD')}</Tooltip>}><Button className="_Btn accept stk o-icn noLine" onClick={() => this.addFormat('<strong>', '</strong>')}><Glyphicon glyph="bold" /></Button></OverlayTrigger>)
    const formatItalic = (<OverlayTrigger placement="left" overlay={<Tooltip id="infoTooltip">{t('MASTERS.ITALICS')}</Tooltip>}><Button className="_Btn accept stk o-icn noLine" onClick={() => this.addFormat('<em>', '</em>')}><Glyphicon glyph="italic" /></Button></OverlayTrigger>)
    const formatmarked = (<OverlayTrigger placement="left" overlay={<Tooltip id="infoTooltip">{t('MASTERS.MARKED')} </Tooltip>}><Button className="_Btn accept stk o-icn noLine" onClick={() => this.addFormat('<mark>', '</mark>')}><Glyphicon glyph="comment" /></Button></OverlayTrigger>)
    const formatLinebreak = (<OverlayTrigger placement="left" overlay={<Tooltip id="infoTooltip">{t('MASTERS.LINEBREAK')} </Tooltip>}><Button className="_Btn accept stk o-icn noLine" onClick={() => this.addFormat('', '<br>')}><Glyphicon glyph="share-alt" /></Button></OverlayTrigger>)
    const formatTabulated = (<OverlayTrigger placement="left" overlay={<Tooltip id="infoTooltip">{t('MASTERS.TABULATED')} </Tooltip>}><Button className="_Btn accept stk o-icn noLine" onClick={() => this.addFormat('<span style="margin-left:15px;">', '</span>')}><Glyphicon glyph="indent-left" /></Button></OverlayTrigger>)
    const formatRed = (<OverlayTrigger placement="left" overlay={<Tooltip id="infoTooltip">{t('MASTERS.RED')} </Tooltip>}><Button className="_Btn cancel stk o-icn noLine" onClick={() => this.addFormat('<span style="color:red;">', '</span>')}><Glyphicon glyph="tint" /></Button></OverlayTrigger>)
    const formatLink = (<OverlayTrigger placement="left" overlay={<Tooltip id="infoTooltip">{t('MASTERS.LINK')} </Tooltip>}><Button className="_Btn accept stk o-icn noLine" onClick={() => this.addFormat(`<a href="${this.state.text}">`, '</a>')}><Glyphicon glyph="link" /></Button></OverlayTrigger>)

    return (
      <Modal id="faqMasterModal" show={showFaqModal} onHide={closeFaqModal} className="_nf" backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>{t('MASTERS.FAQ.TITLE')}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitFaq.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputTreeSelect}
                colWidth={40} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t('MASTERS.FAQ.ORGANIZED_UNIT')}
                placeholder={t('MASTERS.FAQ.ORGANIZED_UNIT')}
                tooltip={renderToolTip}
                multi={false}
                allowClear={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                onInputChange={(e) => this.handleOrganizedUnitChange(e)}
                showSearch={false}
              />
              <Field
                component={InputSelect}
                colWidth={40} // 25, 33, 50, 75, 100 default=25
                name="faqSectionId"
                controlLabel={t('MASTERS.FAQ.FAQ_SECTION')}
                placeholder={t('MASTERS.FAQ.FAQ_SECTION')}
                valueKey="id"
                labelKey="value"
                options={faqSectionCombo}
                isClerable= {false}
              />
              <Field
                component={InputText}
                colWidth={20} // 25, 33, 50, 75, 100 default=25
                name="rating"
                controlLabel={t('MASTERS.FAQ.RATING')}
                placeholder={t('MASTERS.FAQ.RATING')}
              />
            </div>

            { this.state.visibleCustom ? (
              <div>
                <h2 className='masterModalSectionTitle'>{t('MASTERS.FORMAT')}</h2>
                <div className='container-format'>
                  {formatBold}
                  {formatItalic}
                  {formatmarked}
                  {formatLinebreak}
                  {formatTabulated}
                  {formatRed}
                  {formatLink}
                </div>
                <br/>
                <SimpleInputText
                  colWidth={100} // 25, 33, 50, 75, 100 default=25
                  value={this.state.text}
                  id="text"
                  editTooltip={true}
                  onInputChange={text => this.setState({ text })}
                />
                <div className='container-format'>
                  <Button className="_Btn accept o-icn colWidth-100" onClick={() => this.addText()}>
                    <Glyphicon glyph="arrow-down"/>
                  </Button>
                </div>

                <br/>
                <div dangerouslySetInnerHTML={{ __html: this.state.totalText }} className="text-html"/>
                <div className='flexInLine al-R'>
                  <Button className="_Btn new" onClick={() => this.saveFormat()}>
                    {t('MASTERS.SAVE')}
                  </Button>
                  <Button className="_Btn cancel" onClick={() => this.setState({ totalText: '' })}>
                    {t('MASTERS.DELETE')}
                  </Button>
                </div>
              </div>
            ) : (
              <SimpleTablePage
                customClass={'langTable'}
                columns={[
                  <th className='colWidth-15 alignC' key={2}>
                    {t('MASTERS.LANGUAGE')}
                  </th>,
                  <th className='colWidth-30' key={0}>
                    {t('MASTERS.FAQ.FAQ_QUESTION')}
                  </th>,
                  <th className='colWidth-55' key={1}>
                    {t('MASTERS.FAQ.FAQ_ANSWER')}
                  </th>,
                  <th className='actions'>

                  </th>
                ]}
                rows={languageList && languageList.map((val, idx) => (
                  <tr key={idx}>
                    <td className='alignC'>
                      <p><span>{`${val.description}`}</span></p>
                      <p>{`(${val.name})`}</p>
                    </td>
                    <td>
                      <Field
                        component={InputText}
                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                        name={`lang${val.languageId}.name`}
                        placeholder={t('MASTERS.FAQ.FAQ_QUESTION')}
                      />
                    </td>
                    <td>
                      <Field
                        component={InputText}
                        colWidth={100} // 25, 33, 50, 75, 100 default=25
                        name={`lang${val.languageId}.description`}
                        placeholder={t('MASTERS.FAQ.FAQ_ANSWER')}
                        maxLength={100}
                        disabled={true}
                      />
                    </td>
                    <td className='actions'>
                      <div>
                        <a className='_Btn accept stk o-icn ' onClick={() => { this.format(idx, val.languageId) }}>
                          <i className="iDocIcon-edit" />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              />

            )}

          </Modal.Body>
          <Modal.Footer>
            { !this.state.visibleCustom ? (
              <Col className="flexInLine al-R">
                <Button type="submit" className="_Btn new" disabled={this.props.pristine}>
                  {t('MASTERS.SAVE')}
                </Button>
              </Col>
            ) : (
              <div className='flexInLine al-R'>
                <Button className="_Btn accept" onClick={() => this.setState({ visibleCustom: false, totalText: '' }) }>
                  {t('MASTERS.RETURN')}
                </Button>
              </div>
            ) }
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  if (!values.faqSectionId) {
    errors.faqSectionId = props.t('MASTERS.FAQ.VALIDATION.SECTION_REQUIRED')
  }
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`] !== undefined) {
      if (!(values[`lang${language.languageId}`].name)) {
        errors[`lang${language.languageId}`].name = props.t('MASTERS.FAQ.VALIDATION.QUESTION_REQUIRED')
      }
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.FAQ.VALIDATION.ANSWER_REQUIRED')
      }
    }
  })
  return errors
}

export default reduxForm({
  form: 'editFaq',
  validate
})(FaqMasterModal)
